import { render, staticRenderFns } from "./RsaPazienteDiarioPage.vue?vue&type=template&id=d223e200"
import script from "./RsaPazienteDiarioPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteDiarioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports